import React from 'react'
import FormMovieData from '../../forms/FormMovieData'
import WrapperPageSimple from '../../WrapperPage/present/WrapperPageSimple'


const EditMovie = ({
    itemId, 
    movieExtensionsItems, 
    movieExtensionsToReset,
    onUpdateExtension, 
    onResetExtension,
    metaData, 
    sourceData, 
    movies, 
    sourceDataProvider, 
    performances, 
    attributes, 
    movieExist, 
    sourceMoviesByItemId, 
    cliMovieRelevantSourceMovies, 
    closePagePath, 
    onUpdateItem, 
    onChangeField, 
    onResetField
}) => {
    const itemData = movieExist ? movies[itemId] : {}
    const pageName = movieExist && itemData.title ? itemData.title : 'Film nicht gefunden' 
    
    return (
        <WrapperPageSimple
            pageTitle={pageName} 
            closePagePath={closePagePath}
            id={itemId}
        >
            <div className="program-page site-content">
                {movieExist  ? (
                    <FormMovieData 
                        movieData={itemData}
                        metaData={metaData}
                        sourceData={sourceData}
                        sourceDataProvider={sourceDataProvider}
                        attributes={attributes}
                        performances={performances}
                        cliMovieRelevantSourceMovies={cliMovieRelevantSourceMovies}
                        sourceMoviesByItemId={sourceMoviesByItemId}
                        movieExtensionsItems={movieExtensionsItems}
                        movieExtensionsToReset={movieExtensionsToReset}
                        onUpdateExtension={onUpdateExtension}
                        onResetExtension={onResetExtension}
                        closePagePath={closePagePath}
                        onUpdateItem={onUpdateItem}
                        onChangeField={onChangeField}
                        onResetField={onResetField}
                    />
                ):(
                    <div>Keine Daten</div>
                )}
            </div>
        </WrapperPageSimple>
    )
}


export default EditMovie